import React, { useCallback, useEffect, useState } from 'react'
import { Loader } from 'src/components/shared/Loader'
import { cacheWebImages } from '../utils/cacheHelper'

// import regBg from '../images/register/register_bg.png'
// import regBgMobile from '../images/register/register_bg_mobile.png'
// import registerKv from '../images/register/register_visual.png'
// import checkIcon from '../images/register/check_icon.png'
// import infoIcon from '../images/backdrops/info-icon.png'
// import profileIcon from '../images/backdrops/speaker-icon.png'
// import playIcon from '../images/backdrops/play-icon.png'

// import lobby from '../images/backdrops/lobby.jpg'
// import auditorium from '../images/backdrops/auditorium.jpg'
// import boothBg from '../images/backdrops/booth_bg.jpg'
// import entranceArrow from '../images/backdrops/lobby-arrow.png'
// import auditoriumPoster from '../images/backdrops/auditorium-poster.jpg'
// import bannerM from '../images/backdrops/mobile-banner.jpg'
// import helpdeskStand from '../images/backdrops/helpdesk_stand.png'
// import speakersStand from '../images/backdrops/speakersprofile_stand.png'
// import auditoriumEntrance from '../images/backdrops/auditorium_entrance.png'
// import exhibitionEntrance from '../images/backdrops/exhibition_entrance.png'
// import ondemandEntrance from '../images/backdrops/ondemand_entrance.png'
// import galleryMask from '../images/backdrops/galleryMask.png'
import landingBg from '../images/ntc/landing/landing-bg.webp'
import introTitle from '../images/ntc/landing/intro_title.webp'
import introTitleMobile from '../images/ntc/landing/intro_title_mobile.png'
import countdownDesktopBg from '../images/ntc/general/bg.webp'
import countdownTitle from '../images/ntc/landing/countdown-title.png'
import countdownMobileBg from '../images/ntc/general/mobile-bg.jpg'
import countdownMobileTitle from '../images/ntc/landing/countdown-title-mobile.png'
import countdownEditionLogo from '../images/ntc/landing/countdown-edition-logo.png'
import countdownOrganizerLogos from '../images/ntc/landing/countdown-organizer-logos.png'
import organizerLogo from '../images/ntc/general/logo.png'
import landingBgMobile from '../images/ntc/landing/landing-bg-mobile.png'
import loginLandingBgMobile from '../images/ntc/landing/landing-bg-mobile.webp'
import masthead from '../images/ntc/landing/masthead.png'
import mastheadMobile from '../images/ntc/landing/masthead-mobile.png'
import headerOrganizer from '../images/ntc/landing/header-logo.png'
import loginBg from '../images/ntc/login/login-bg.webp'
import loginHeroBg from '../images/ntc/general/bg.webp'
import lobbyBg from '../images/ntc/lobby/lobby-bg.webp'
import lobbyHelpDeskIcon from '../images/ntc/lobby/helpdesk-icon.png'
import agendaIcon from '../images/ntc/lobby/agenda-icon.png'
import speakerIcon from '../images/ntc/lobby/speaker-icon.png'
import hallIcon from '../images/ntc/lobby/hall-icon.png'
import galleryIcon from '../images/ntc/lobby/gallery-icon.png'
import surveyIcon from '../images/ntc/lobby/survey-icon.png'
import lobbyGuide  from '../images/ntc/lobby/guide.jpg'
import mobileAuditoriumIcon from '../images/ntc/lobby/mobile-plenary.png'
import mobileAgenda from '../images/ntc/lobby/mobile-agenda.png'
import mobileGallery from '../images/ntc/lobby/mobile-gallery.png'
import mobileSurvey from '../images/ntc/lobby/mobile-survey.png'
import mobileHelp from '../images/ntc/lobby/mobile-help.png'
import auditoriumBg from '../images/ntc/auditorium/hall-bg.webp'
import auditoriumBanner from '../images/ntc/auditorium/banner.png'
import mobileAuditoriumBg from '../images/ntc/auditorium/mobile-auditorium.webp'
import hallMasthead from '../images/ntc/auditorium/hall-masthead-mobile.png'
import speakerHeader from '../images/ntc/general/banner.jpg'
import homeButtonIcon from '../images/ntc/general/home-button-icon.svg'
import programme1 from '../images/ntc/programme/Day1.jpg'
import programme2 from '../images/ntc/programme/Day2.jpg'
import galleryBg from '../images/ntc/general/bg.webp'
import galleryMasthead from '../images/ntc/gallery/masthead.png'
import galleryBg2 from '../images/ntc/general/bg.webp'
import videoIcon from '../images/ntc/gallery/video.png'
import folderIcon from '../images/ntc/gallery/folder.png'
import docIcon from '../images/ntc/gallery/doc.png'

import speaker1 from '../images/ntc/speakers/01-speaker_profile.webp';
import speaker2 from '../images/ntc/speakers/02-speaker_profile.webp';
import speaker3 from '../images/ntc/speakers/03-speaker_profile.webp';
import speaker4 from '../images/ntc/speakers/04-speaker_profile.webp';
import speaker5 from '../images/ntc/speakers/05-speaker_profile.webp';
import speaker6 from '../images/ntc/speakers/06-speaker_profile.webp';
import speaker7 from '../images/ntc/speakers/07-speaker_profile.webp';
import speaker8 from '../images/ntc/speakers/08-speaker_profile.webp';
import speaker9 from '../images/ntc/speakers/09-speaker_profile.webp';
import speaker10 from '../images/ntc/speakers/10-speaker_profile.webp';
import speaker11 from '../images/ntc/speakers/11-speaker_profile.webp';
import speaker12 from '../images/ntc/speakers/12-speaker_profile.webp';
import speaker13 from '../images/ntc/speakers/13-speaker_profile.webp';
import speaker14 from '../images/ntc/speakers/14-speaker_profile.webp';
import speaker15 from '../images/ntc/speakers/15-speaker_profile.webp';
import speaker16 from '../images/ntc/speakers/16-speaker_profile.webp';
import speaker17 from '../images/ntc/speakers/17-speaker_profile.webp';
import speaker18 from '../images/ntc/speakers/18-speaker_profile.webp';
import speaker19 from '../images/ntc/speakers/19-speaker_profile.webp';
import speaker20 from '../images/ntc/speakers/20-speaker_profile.webp';
import speaker21 from '../images/ntc/speakers/21-speaker_profile.webp';
import speaker22 from '../images/ntc/speakers/22-speaker_profile.webp';
import speaker23 from '../images/ntc/speakers/23-speaker_profile.webp';
import speaker24 from '../images/ntc/speakers/24-speaker_profile.webp';
import speaker25 from '../images/ntc/speakers/25-speaker_profile.webp';
import playBtn from '../images/ntc/lobby/play-btn.png'
import hallKv from '../images/ntc/auditorium/hall-kv.png'
import userGuideBtn from '../images/ntc/lobby/user-guide-btn.png'
import faqBtn from '../images/ntc/lobby/faq-btn.png'
import gallerySidebarBg from '../images/ntc/gallery/gallery-sidebar.jpg'

export const fixedAssets = {
  // registerKv,
  // regBg,
  // regBgMobile,
  // checkIcon,
  // bannerM,
  // helpdeskStand,
  // speakersStand,
  // infoIcon,
  // profileIcon,
  // boothBg,
  // playIcon,
  // galleryMask,
  // lobby,
  // auditorium,
  // auditoriumPoster,
  // entranceArrow,
  // auditoriumEntrance,
  // exhibitionEntrance,
  // ondemandEntrance,
  organizerLogo,
  headerOrganizer,
  auditoriumBanner,
  speakerHeader,
  homeButtonIcon,
  programme1,
  programme2,
  folderIcon,
  videoIcon,
  docIcon,
  playBtn,
}

export const desktopAssets = {
  hallKv,
  landingBg,
  countdownDesktopBg,
  countdownTitle,
  masthead,
  galleryMasthead,
  galleryBg,
  loginBg,
  loginHeroBg,
  introTitle,
  lobbyBg,
  lobbyHelpDeskIcon,
  agendaIcon,
  lobbyGuide,
  speakerIcon,
  hallIcon,
  galleryIcon,
  surveyIcon,
  auditoriumBg,
  galleryBg2,
  userGuideBtn,
  faqBtn,
  speaker1,
  speaker2,
  speaker3,
  speaker4,
  speaker5,
  speaker6,
  speaker7,
  speaker8,
  speaker9,
  speaker10,
  speaker11,
  speaker12,
  speaker13,
  speaker14,
  speaker15,
  speaker16,
  speaker17,
  speaker18,
  speaker19,
  speaker20,
  speaker21,
  speaker22,
  speaker23,
  speaker24,
  speaker25,
  gallerySidebarBg,
}

export const mobileAssets = {
  landingBgMobile,
  countdownMobileBg,
  countdownMobileTitle,
  countdownEditionLogo,
  countdownOrganizerLogos,
  loginHeroBg: countdownMobileBg,
  introTitleMobile,
  landingBg,
  mastheadMobile,
  mobileAuditoriumIcon,
  mobileAgenda,
  mobileGallery,
  mobileSurvey,
  mobileHelp,
  mobileAuditoriumBg,
  loginLandingBgMobile,
  dashboardBg: countdownMobileBg,
  lobbyTitle: countdownMobileTitle,
  hallMasthead,
}

export const PreCache = ({ deviceType, children }) => {
  const [pageLoading, setPageLoading] = useState(false)

  const preloadAssets = useCallback(async () => {
    setPageLoading(true)
    await cacheWebImages(Object.values({
      ...fixedAssets,
      ...deviceType === 'desktop' ? desktopAssets : mobileAssets
    }))
    setPageLoading(false)
  }, [])

  useEffect(() => {
    preloadAssets()
  }, [deviceType, preloadAssets])

  return (
    <Loader loading={pageLoading} fullPage>
      <>{children}</>
    </Loader>
  )
}
